import { Badge } from '@sgme/ui';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';

import './style.scss';
import { useAppSelector } from 'hooks/useAppSelector';
import { FormattedMessage } from 'react-intl';
import { getPrompt } from 'state/workspaces/smart-quote/selectors';

type ParsingBadgeProps = {
  promptId: string;
};

const ParsingBadge = ({ promptId }: ParsingBadgeProps) => {
  const tabId = useAssertedActiveTabId();
  const prompt = useAppSelector(state => getPrompt(state, tabId, promptId));

  const isParsingFinished = prompt?.status === 'Finished';

  if (isParsingFinished) {
    return (
      <div className="text-secondary flex-x gap-2">
        <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="8.86621" cy="14.95" rx="3.375" ry="0.75" fill="currentColor"></ellipse>
          <ellipse cx="8.99987" cy="12.2384" rx="6.61608" ry="1.17054" fill="currentColor"></ellipse>
          <ellipse cx="9" cy="8.59998" rx="8" ry="1.5" fill="currentColor"></ellipse>
          <ellipse cx="8.99987" cy="5.0116" rx="6.61608" ry="1.17054" fill="currentColor"></ellipse>
          <ellipse cx="8.87109" cy="2.34998" rx="3.375" ry="0.75" fill="currentColor"></ellipse>
        </svg>
        <Badge color="secondary" isPill purpose="outline" size="sm">
          <FormattedMessage id="smartQuote.workspace.main.parsingBadge.finished.text" />
        </Badge>
      </div>
    );
  }

  return (
    <div className="text-primary flex-x gap-2">
      <div className="shape-container">
        <div className="olive olive1 bg-primary"></div>
        <div className="olive olive2 bg-primary"></div>
        <div className="olive olive3 bg-primary"></div>
        <div className="olive olive4 bg-primary"></div>
        <div className="olive olive5 bg-primary"></div>
      </div>
      <Badge color="secondary" isPill purpose="flat" size="sm">
        <FormattedMessage id="smartQuote.workspace.main.parsingBadge.thinking.text" />
      </Badge>
    </div>
  );
};

export default ParsingBadge;
